import { useEffect } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import BundleAddDialogComponent from "./BundleAddDialog.component";
import { createBundle, getModuleListing } from "../../redux/bundles.action";
import { selectLoading } from "../../../notification";

export default function BundleAddDialogContainer({ open, onClose, onCreate, prefill }) {
  const isLoading = useSelector((state) =>
    selectLoading(state, createBundle.typePrefix));
  const moduleListing = useSelector((state) =>
    state.bundles.moduleListing);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      // Authoring a bundle only ever offers the ACTIVE modules to compose from — a retired
      // module is not something a new bundle should be built on. The cache is shared with the
      // company/approval dialogs, which populate it with the FULL (retired-included) set, so
      // this always refetches active-only on open rather than trusting whatever happens to be
      // cached — otherwise a company dialog opened earlier in the session would leave inactive
      // modules on offer here.
      dispatch(getModuleListing({ activeOnly: true }));
    }
  }, [open]);

  const onSubmit = (value) => {
    dispatch(createBundle({
      name: value.name,
      description: value.description,
      moduleIds: value.moduleIds,
    }))
      .then(unwrapResult)
      .then(() => {
        onClose();
        onCreate();
      })
      .catch(() => {});
  };

  return <BundleAddDialogComponent
    moduleListing={moduleListing}
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
    isLoading={isLoading}
    prefill={prefill}
  />;
}
